import { Toggle as CarbonToggle } from "carbon-components-react";
import { useEffect, useState } from "react";

const Toggle = (props) => {
  const [initialValue, setInitialValue] = useState(true);
  const [key, setKey] = useState('');
  const [value, setValue] = useState(false);

  useEffect(() => {
    setInitialValue(props.defaultToggled);
    setValue(props.defaultToggled)
    window.setTimeout(() => {
      setKey("reloaded");
    }, 1000)
  }, [props.defaultToggled]);

  const onToggle = (e) => {
    const newValue = !value
    props.onToggle(newValue)
    setValue(newValue)
  }

  return (
    <CarbonToggle
      aria-label={props.id}
      defaultToggled={initialValue}
      toggled={value}
      id={props.id}
      name={props.name}
      labelText={props.labelText}
      onChange={(e) => onToggle(e)}
      labelA={props.labelA}
      labelB={props.labelB}
      disabled={props.disabled}
    // key={"toggle-" + key}
    />
  );
};

export default Toggle
